/**
 * 渠道筛选器组件
 * 独立管理渠道选择状态，返回值格式与 OpinionChannel.backValue 一致
 * change 只更新内部 UI 状态，onClose（下拉框关闭）时才回调父组件
 */
import React, { useMemo, useRef, useState } from 'react';
import { RadioAllMultipleSelect } from '@opm/components/FilterCommon/components/RadioAllMultipleSelect';
import ChannelLabel from '@op/components/ChannelLabel';
import type { IChannelOptionItem } from './types';

interface IChannelFilterProps {
  channelOptions: IChannelOptionItem[];
  onChange: (
    value: { dimension_values?: string[]; need_others?: boolean } | null,
  ) => void;
}

const ChannelFilter: React.FC<IChannelFilterProps> = ({
  channelOptions,
  onChange,
}) => {
  const [selectedChannels, setSelectedChannels] = useState<string[]>([]);
  // 记录上次已上报的值，避免关闭时重复触发
  const lastReportedRef = useRef<string[]>([]);

  const options = useMemo(() => {
    return channelOptions.map((item) => ({
      value: item.value,
      text: item.label_en,
      textCn: item.label_zh,
    }));
  }, [channelOptions]);

  // change 只更新内部 UI，不触发父组件请求
  function handleChange(newValue: string[]) {
    setSelectedChannels(newValue);
  }

  // 下拉框关闭时，比对变化后回调父组件
  function handleClose() {
    if (
      selectedChannels.length === lastReportedRef.current.length &&
      selectedChannels.every((v) => lastReportedRef.current.includes(v))
    ) {
      return;
    }

    lastReportedRef.current = selectedChannels;

    if (selectedChannels.length === 0) {
      onChange({ dimension_values: [] });
      return;
    }

    const allOptionValues = options.map((opt) => opt.value);
    const isAllSelected =
      selectedChannels.length === allOptionValues.length &&
      allOptionValues.every((val) => selectedChannels.includes(val));

    const result: { dimension_values: string[]; need_others?: boolean } = {
      dimension_values: selectedChannels,
    };
    if (isAllSelected) {
      result.need_others = true;
      result.dimension_values = [];
    }

    onChange(result);
  }

  if (options.length === 0) return null;

  return (
    <RadioAllMultipleSelect
      options={options}
      value={selectedChannels}
      change={handleChange}
      filterValue={{ dimension_values: selectedChannels }}
      onClose={handleClose}
      title="Channel"
      titleCn="渠道"
      valueKeys="dimension_values"
      itemRender={(item: any) => (
        <ChannelLabel
          iconStyle={{ width: 18, height: 18 }}
          channel_name={item?.value as 'tiktok'}
          isMarketing
        />
      )}
      matchButtonWidth
      allText="Top 10"
      allTextCn="前10"
      leftText="Channel"
    />
  );
};

export default React.memo(ChannelFilter);
